import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import protfolioData from "../data/protfolioData";
import { X } from "../../assets/icons/icons";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function Portfolio() {
    const { t } = useTranslation();
    UseScrollAnimation();
    

    const [selectedCategory, setSelectedCategory] = useState("All");
    const [selectedImage, setSelectedImage] = useState(null);

    const handleCategoryChange = (category) => {
        setSelectedCategory(category);
    };

    const filteredData = selectedCategory === "All"
        ? protfolioData
        : protfolioData.filter(item => item.mainCategories === selectedCategory);

    return (
        <>
            <section className="landingPages">
                <div className="container h-[70vh] flex flex-col justify-center gap-[10px]">
                    <div className="btmAni2000 text-[40px] font-bold text-white  capitalize">{t("Portfolio")}</div>
                    <div className="btmAni25002 flex items-center gap-[5px] text-white">
                        <Link className="text-white" to={"/"}>{t("Home")}</Link>
                        -
                        <div className="text-[#016E82]">{t("Portfolio")}</div>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container">
                    <div className="flex gap-[10px] mb-[20px] overflow-x-scroll no-scrollbar">
                        {["All", "Aqaba", "Petra", "Wadi Rum"].map((category) => (
                            <button
                                key={category}
                                className={`btmAni20002 w-fit py-[10px] px-[20px] text-[#016E82] rounded-[4px] ${selectedCategory === category ? 'bg-[#016E82] text-white' : 'bg-white text-[#016E82]'
                                    }`}
                                onClick={() => handleCategoryChange(category)}
                            >
                                {t(category)}
                            </button>
                        ))}
                    </div>

                    <div>
                        <div className="flex flex-wrap gap-4">
                            {filteredData.map((category) =>
                                category.data.map((image, index) => (
                                    <div key={index} className="btmAni3000 w-46 relative w-[22%] h-[250px]">
                                        <img
                                            src={image}
                                            alt={category.mainCategories}
                                            className="w-full h-full object-cover cursor-pointer rounded-lg shadow-lg hover:scale-105 transition duration-300"
                                            onClick={() => setSelectedImage(image)}
                                            
                                        />
                                    </div>
                                ))
                            )}
                        </div>

                        {selectedImage && (
                            <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 backdrop-blur-md">
                                <div className="relative p-4">
                                    <button
                                        className="absolute top-[2rem] right-[2rem] text-white bg-black bg-opacity-50 p-2 rounded-full hover:bg-opacity-80 transition"
                                        onClick={() => setSelectedImage(null)}
                                    >
                                        <X size={28} />
                                    </button>
                                    <div className="w-350-px h-350-px w-[500px] h-[500px] flex items-center justify-center">
                                        <img
                                            src={selectedImage}
                                            alt="Full Size"
                                            className="w-full h-full rounded-lg shadow-lg transition-opacity duration-300"
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                </div>
            </section>
        </>
    );
}
